export const MAXIMUM_STARTER_PLAN_REQUESTS = 5;